import React from 'react';

const TermsOfUse = () => {
  return (
    <div className="page-container">
      <h1>Terms of Use</h1>
      <p>
        Welcome to VoinoxAI. These Terms of Use govern your access to and use of our services. By accessing or using our platform, you agree to comply with these terms. Please read them carefully.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By using VoinoxAI, you agree to be bound by these Terms of Use and our Privacy Policy. If you do not agree to these terms, you may not use our services.
      </p>

      <h2>2. Eligibility</h2>
      <p>
        You must be at least 18 years old to use VoinoxAI. By using our platform, you confirm that you meet this requirement.
      </p>

      <h2>3. User Responsibilities</h2>
      <p>
        When using VoinoxAI, you agree to:
      </p>
      <ul>
        <li>Use the service only for lawful purposes and in accordance with these terms.</li>
        <li>Not upload or share content that infringes on the rights of others or violates any applicable laws.</li>
        <li>Keep your account credentials secure and not share them with others.</li>
      </ul>

      <h2>4. Subscriptions and Billing</h2>
      <p>
        VoinoxAI offers subscription plans billed monthly. By subscribing, you agree to:
      </p>
      <ul>
        <li>Provide accurate and complete billing information.</li>
        <li>Authorize us to charge your payment method for the subscription fees.</li>
        <li>Cancel your subscription at any time through your account settings.</li>
      </ul>

      <h2>5. Suspension and Termination</h2>
      <p>
        We reserve the right to suspend or terminate accounts that:
      </p>
      <ul>
        <li>Violate these terms or applicable laws.</li>
        <li>Engage in fraudulent or harmful activities.</li>
        <li>Fail to maintain valid payment information for subscription services.</li>
      </ul>

      <h2>6. Intellectual Property</h2>
      <p>
        All content, trademarks, and other intellectual property on VoinoxAI are owned by us or our licensors. You may not use, copy, or distribute this content without prior written permission.
      </p>

      <h2>7. Disclaimer of Warranties</h2>
      <p>
        VoinoxAI is provided "as is" without any warranties of any kind. We do not guarantee the accuracy or reliability of the services provided.
      </p>

      <h2>8. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, VoinoxAI and its affiliates will not be liable for any indirect, incidental, or consequential damages arising from your use of the platform.
      </p>

      <h2>9. Changes to Terms</h2>
      <p>
        We may update these Terms of Use from time to time. Continued use of VoinoxAI after changes to the terms constitutes your acceptance of the updated terms.
      </p>

      <h2>10. Contact Us</h2>
      <p>
        If you have any questions about these Terms of Use, please contact us at <a href="mailto:support@voinoxai.com">support@voinoxai.com</a>.
      </p>

      <p>Last Updated: January 8, 2025</p>
    </div>
  );
};

export default TermsOfUse;
